import React from 'react';
import { Menu, User, LogOut } from 'lucide-react';

const Header = ({ activeTab, setSidebarOpen, onLogout }) => {
  const getPageTitle = () => {
    const titles = {
      'dashboard': 'Dashboard',
      'basic-info': 'Basic Information',
      'site': 'Site Settings', // ADD THIS LINE
      'policies': 'Policies',
      'api': 'API Settings',
      'products': 'Products',
      'categories': 'Categories',
      'orders': 'Orders',
      'customers': 'Customers',
      'content': 'Content Management'
    };
    return titles[activeTab] || 'Admin Panel';
  };

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      onLogout();
    }
  };

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="flex items-center justify-between h-16 px-6">
        <div className="flex items-center">
          <button
            className="lg:hidden p-2 rounded-md hover:bg-gray-100"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu className="h-5 w-5" />
          </button>
          <h2 className="ml-2 text-lg font-semibold text-gray-900 lg:ml-0">
            {getPageTitle()}
          </h2>
        </div>
        
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
              <User className="h-4 w-4 text-white" />
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center space-x-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
              title="Logout"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:block">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;